import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PageShell } from '@shared/components/page-shell/page-shell';
import { DASHBOARD_QUICK_LINKS, DASHBOARD_STATS } from './dashboard.data';

@Component({
  selector: 'app-dashboard',
  imports: [PageShell, RouterLink],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
})
export class Dashboard {
  protected readonly stats = DASHBOARD_STATS;
  protected readonly quickLinks = DASHBOARD_QUICK_LINKS;
}
